import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { routes, IRoute } from '@/router/route';
import BHeaders from '@/component/header/BHeader';
import './index.scss';
import login from '@/view/login/login.tsx';
function LouterPath() {
    if (window.location.href.indexOf('loginInne') > -1) {
        return <Route key={`login-key`} path='/loginInne' component={login} />;
    } else {
        return (
            <div className={`main ${!(window.self === window.top) ? 'isiframe' : ''}`}>
                <div className='header'>
                    <BHeaders />
                </div>
                <div className='content'>
                    {routes.map((route: IRoute, index: number) => {
                        if (route.subRoutes) {
                            return (
                                <Switch key={index}>
                                    {route.subRoutes.map((subRoute: IRoute, subIndex: number) => (
                                        <Route key={index + '-' + subIndex} exact={subRoute.exact} path={route.path + subRoute.path} component={subRoute.comp} />
                                    ))}
                                    {route.redirect && <Redirect exact={true} from={route.path} to={route.redirect} />}
                                </Switch>
                            );
                        } else {
                            return <Route key={index} exact={route.exact} path={route.path} component={route.comp} />;
                        }
                    })}
                </div>
            </div>
        );
    }
}

@observer
class App extends React.Component<any, {}> {
    state = {};
    render() {
        return (
            <Router>
                <LouterPath />
                {/* {window.location.href.indexOf('loginInne') > -1 && <Route key={`login-key`} path='/loginInne' component={login} />}
                {window.location.href.indexOf('loginInne') <= -1 && (
                    <div className={`main ${!(window.self === window.top) ? 'isiframe' : ''}`}>
                        <div className='header'>
                            <BHeaders />
                        </div>
                        <div className='content'>
                            {routes.map((route: IRoute, index: number) => {
                                if (route.subRoutes) {
                                    return (
                                        <Switch key={index}>
                                            {route.subRoutes.map((subRoute: IRoute, subIndex: number) => (
                                                <Route key={index + '-' + subIndex} exact={subRoute.exact} path={route.path + subRoute.path} component={subRoute.comp} />
                                            ))}
                                            {route.redirect && <Redirect exact={true} from={route.path} to={route.redirect} />}
                                        </Switch>
                                    );
                                } else {
                                    return <Route key={index} exact={route.exact} path={route.path} component={route.comp} />;
                                }
                            })}
                        </div>
                    </div>
                )} */}
            </Router>
        );
    }
}

export default App;
